export function hasValue<T extends any | undefined | null>(
  input: T | undefined | null,
): input is T {
  if (input === undefined || input === null) {
    return false;
  }

  return true;
}

export function hasStringValue(input: string | undefined | null): input is string {
  if (!hasValue(input)) {
    return false;
  }

  return input.trim().length > 0;
}
